import { combineReducers } from '@reduxjs/toolkit'
import layoutReducer, {
  commonReducers,
} from '../components/templates/default/slice'
import authAdmin from '../components/organisms/admin/auth/slice'
import userSlice from '../components/organisms/admin/account/slice'
import menuSlice from '../components/organisms/admin/menu/slice'
import kitchenSlice from '../components/organisms/admin/kitchen/slice'
import configSlice from '../components/organisms/admin/oder-time/slice'
import roleSlice from '../components/organisms/admin/roles/slice'
import questionslice from '../components/organisms/admin/question/slice'
import authPortal from '../components/organisms/portal/auth/slice'
export default combineReducers({
  layout: layoutReducer,
  commonReducers: commonReducers.reducer,
  userlist: userSlice,
  authAdmin: authAdmin,
  menulist: menuSlice,
  kitChenList: kitchenSlice,
  configsList: configSlice,
  rolesList: roleSlice,
  questionsList: questionslice,
  auth: authPortal
})
